import { render, staticRenderFns } from "./EditGroupMember.vue?vue&type=template&id=7f734b5b"
import script from "./EditGroupMember.vue?vue&type=script&lang=js"
export * from "./EditGroupMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports